import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ViewerPage } from "../../../../features/viewer/components/viewer-page";

/** FR-VW-*, FR-COL-04: /w/:slug/r/REP-128?tab=network&t=84 */
export const Route = createFileRoute("/w/$slug/r/$reportKey")({
  validateSearch: z.object({
    tab: z.enum(["info", "console", "network", "actions"]).optional().catch(undefined),
    t: z.coerce.number().int().min(0).optional().catch(undefined),
  }),
  component: () => {
    const { reportKey } = Route.useParams();
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <ViewerPage
        key={reportKey}
        reportKey={reportKey}
        tab={search.tab ?? "network"}
        startSeconds={search.t}
        onTab={(tab) =>
          void navigate({ search: (previous) => ({ ...previous, tab }), replace: true })
        }
      />
    );
  },
});
